import React, { Component } from 'react';
import classNames from 'classnames';

import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './ReferentCategoryForm';

export default class ReferentCategoryCrear extends Component {
    state = {
        editar: false,
        mensaje: 'Agregar Categoria',
        password: false,
    }

    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar Subcategoria'
            });
        }
    }

    render() {
        const {
            create,
            update,
            editar,
            cargando,
            updateData,
            isNavBarOpen,
        } = this.props;

        const edit = window.location.href.includes("edit");

        return (
            <div className={classNames('content', { 'content-min': isNavBarOpen })}>
                <div className="m-auto row-fluid card-form">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {edit ? (
                                <div className="fields">
                                    <div className="top-title">
                                        CATEGORIA
                                    </div>
                                    <Form
                                        editando
                                        onSubmit={update}
                                        updateData={updateData}
                                    />
                                </div>
                            ) : (
                                <div className="fields">
                                    <div className="top-title">
                                        CREAR CATEGORIA
                                    </div>
                                    <Form onSubmit={create} />
                                </div>
                            )}
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
